import { render, staticRenderFns } from "./ModalExpense.vue?vue&type=template&id=0ebd6cf6&scoped=true&"
import script from "./ModalExpense.vue?vue&type=script&lang=js&"
export * from "./ModalExpense.vue?vue&type=script&lang=js&"
import style0 from "./ModalExpense.vue?vue&type=style&index=0&id=0ebd6cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebd6cf6",
  null
  
)

export default component.exports